__webpack_require__.p = "/artikel-ansicht3d/";